module.exports = __webpack_public_path__ + "img/hoozieRewardsField3Mobile.7b364e75.svg";